import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const store = new Vuex.Store({
    state: {
        name: ''
    },
    mutations: {
        loginIn(state, name) {
            state.name = name   
        },
    
        loginOut(state) {
            state.name = ''
    
        }
    } 
    
});

export default store
